import React, { FC, useMemo } from 'react'
import KeepTruckinLogo from 'assets/logos/keeptruckin-logo.svg'
import Project44Logo from 'assets/logos/project44-logo.svg'
import TransfixLogo from 'assets/logos/transfix-logo.svg'
import AddIcon from 'transfix-icons/build/AddIcon'
import { Box, makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { TRACKING_METHOD_TYPE } from 'types/tracking'
import { useFMSAnalytics, useFMSRoutes } from 'apps/fleet-planner/hooks'
import { Button } from 'transfix-ui'

const useStyles = makeStyles(theme => ({
  add: {
    width: 24,
    height: 24,
    color: brandColors.coolGray8,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}))
export interface IIntegrationMessage {
  trackingProvider: TRACKING_METHOD_TYPE
  carrierId?: number
}

interface IConfigOptions {
  logo: string
  message: string
  buttonMessage: string
  onLinkClickHandler: () => void
}

interface IConfig extends Partial<Record<TRACKING_METHOD_TYPE, IConfigOptions>> {}

export const IntegrationMessage: FC<IIntegrationMessage> = ({ carrierId, trackingProvider }) => {
  const { trackEvent } = useFMSAnalytics()
  const history = useFMSRoutes()
  const classes = useStyles()

  const values = useMemo<IConfig>(
    () => ({
      [TRACKING_METHOD_TYPE.keepTruckin]: {
        logo: KeepTruckinLogo,
        message: 'Connect your KeepTruckin account to enable ELD tracking for your carrier.',
        buttonMessage: 'Connect Your KeepTruckin Account',
        onLinkClickHandler: () => {
          trackEvent('ELD', 'CLICKED_CONNECT_KEEP_TRUCKIN_CTA')
          history.pushToConnectCarrier(carrierId || '', true)
        },
      },
      [TRACKING_METHOD_TYPE.project44]: {
        logo: Project44Logo,
        message:
          'Connect your project44 account to enable ELD tracking from over 750+ ELD providers.',
        buttonMessage: 'Connect With Project44',
        onLinkClickHandler: () => {
          trackEvent('ELD', 'CLICKED_CONNECT_P44_CTA')
          const win = window.open(
            'https://na12.voc.project44.com/portal/v2/public/connect/transfix',
            '_blank'
          )

          if (win) win.focus()
        },
      },
    }),
    [carrierId, history]
  )

  const config = values[trackingProvider]

  if (!config) {
    return null
  }

  return (
    <Box py={5} display='flex' flexDirection='column' alignItems='center' bgcolor='#F3F5F7'>
      <Box display='flex' alignItems='center' mb={2}>
        <img src={TransfixLogo} alt='Transfix Logo' />
        <AddIcon className={classes.add} />
        <img src={config.logo} alt='ELD Logo' />
      </Box>
      {config.message}
      <Box mt={3} display='flex' flexDirection='column' alignItems='center'>
        <Button color='primary' onClick={config.onLinkClickHandler}>
          {config.buttonMessage}
        </Button>
        <Box mt={2} color={brandColors.coolGray5} fontWeight={600}>
          You can do this later
        </Box>
      </Box>
    </Box>
  )
}
